<template>
  <a-form layout="vertical" :model="filters">
    <a-form-item label="ФИО">
      <a-input v-model:value="filters.name" placeholder="Фио"/>
    </a-form-item>

    <a-row :gutter="10">
      <a-col>
        <a-form-item label="Должность">
          <a-input v-model:value="filters.job_title" placeholder="Название должности" />
        </a-form-item>
      </a-col>

      <a-col>
        <a-form-item label="Отдел">
          <a-input v-model:value="filters.department" placeholder="Название отдела" />
        </a-form-item>
      </a-col>
    </a-row>

    <a-row :gutter="10">
      <a-col>
        <a-form-item label="Почта">
          <a-input v-model:value="filters.email" placeholder="Почта" />
        </a-form-item>
      </a-col>

      <a-col>
        <a-form-item label="Телефон">
          <a-input v-model:value="filters.telephone" placeholder="Телефон" />
        </a-form-item>
      </a-col>
    </a-row>

    <a-form-item label="Группа">
      <a-select
          v-model:value="filters.groups"
          mode="multiple"
          :placeholder="'Не выбрано'"
          :not-found-content="'Нет данных'"
      >
        <a-select-option v-for="e in groups" :key="e.id" :value="e.id">
          {{ e.name }}
        </a-select-option>
      </a-select>
    </a-form-item>

    <a-row :gutter="10">
      <a-col :span="12">
        <a-form-item label="Дата добавления" name="created_at">
          <a-date-picker
              v-model:value="filters.created_at"
              type="date"
              placeholder="Выберите дату"
              style="width: 100%"
          />
        </a-form-item>
      </a-col>

      <a-col :span="12">
        <a-form-item label="Последний вход" name="online_from">
          <a-date-picker
              v-model:value="filters.online_from"
              type="date"
              placeholder="Выберите дату"
              style="width: 100%"
          />
        </a-form-item>
      </a-col>
    </a-row>

    <a-row justify="end" :gutter="8">
      <a-col>
        <a-button :class="'secondary-button'" @click="closeForm">Отменить</a-button>
      </a-col>
      <a-col>
        <a-button :class="'primary-button'" @click="updateFilters">Применить</a-button>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import {onBeforeMount, reactive, ref, watch} from "@vue/runtime-core";
import {useStore} from "vuex";
import {computed} from "@vue/reactivity";

export default {
  props: {
    currentGroupId: [Number, String],
  },
  emits: ['close'],
  setup(props, context) {
    const currentFiltersLine = ref('');
    const store = useStore();
    const groups = computed(() => store.state.group.groups);

    const storedFilters = computed(() => store.state.users.filters);

    const filters = reactive({
      name: storedFilters.value.name ?? '',
      job_title: storedFilters.value.job_title ?? '',
      department: storedFilters.value.department ?? '',
      online_from: storedFilters.value.online_form ?? '',
      created_at: storedFilters.value.created_at ?? '',
      email: storedFilters.value.email ?? '',
      telephone: storedFilters.value.telephone ?? '',
      groups: storedFilters.value.groups ?? [],
      without_group_only: storedFilters.value.without_group_only ?? false,
    });

    const filterStringLabels = {
      name: 'ФИО',
      job_title: 'Должность',
      department: 'Подразделение',
      online_from: 'Дата входа',
      created_at: 'Дата создания',
      email: 'Почта',
      telephone: 'Телефон',
      groups: 'Группы',
      without_group_only: 'Без группы',
    }

    const buildInputLineString = () => {
      currentFiltersLine.value = '';
      Object.entries(filterStringLabels).map(
          ([key, value]) => {
            if (filters[key]) {
              let newString;

              if (key === 'groups') {
                filters[key].forEach((groupId) => {
                  let currentGroup = groups.value?.find((groupData) => groupData.id === groupId);
                  newString = (newString ? newString + ', ' : '') + currentGroup.name;
                });
                newString = newString ? `${value}: ${newString}` : '';
              } else if (key === 'created_at' || key === 'online_from') {
                newString = `${value}: ${filters[key].format('DD.MM.YYYY')}`;
              } else {
                newString = `${value}: ${filters[key]}`;
              }

              if (newString) {
                currentFiltersLine.value = (currentFiltersLine.value ? currentFiltersLine.value + ', ' : '') + `${newString}`
              }
            }
          }
      );
    }

    const updateFilters = () => {
      if (filters.groups.length) {
        filters.without_group_only = false;
      }

      if (props.currentGroupId) {
        filters.current_group = props.currentGroupId;
      }

      buildInputLineString();

      store.dispatch('users/setUserFilters', {
        filters: filters,
        filterString: currentFiltersLine,
      });

      closeForm();
    }

    const closeForm = () => {
      context.emit('close');
    }

    watch(storedFilters, () => {
        filters.name = storedFilters.value.name ?? '';
        filters.job_title = storedFilters.value.job_title ?? '';
        filters.department = storedFilters.value.department ?? '';
        filters.online_from = storedFilters.value.online_form ?? '';
        filters.created_at = storedFilters.value.created_at ?? '';
        filters.email = storedFilters.value.email ?? '';
        filters.telephone = storedFilters.value.telephone ?? '';
        filters.groups = storedFilters.value.groups ?? [];
        filters.current_group = storedFilters.value.current_group ?? null;
        filters.without_group_only = storedFilters.value.without_group_only ?? false;
    });

    return {
      filters,
      updateFilters,
      closeForm,
      groups
    }
  }
}
</script>

<style scoped lang="scss">
:deep(.ant-form-item-label) {
  padding-bottom: 4px !important;
}

:deep(.ant-form-item) {
  margin-bottom: 12px;
}
</style>